import createReducer from "../../lib/createReducer";
import * as types from "../../actions/types";

const initialState = {
  items: [],
  createdItem: null,
  deletedItemName: null,
};

export default createReducer(initialState, {
  [types.VEHICLES_SET_MULTI_DASH_GROUPS](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    newState.items = action.state.items;

    return newState;
  },

  [types.VEHICLES_SET_CREATED_MULTI_DASH_GROUP](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    newState.createdItem = action.state.item;
    newState.items.unshift(newState.createdItem);

    return newState;
  },

  [types.VEHICLES_SET_DELETED_MULTI_DASH_GROUP_ID](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    const { name } = action.state;
    newState.deletedItemName = name;
    newState.items = newState.items.filter((i) => i.name !== name);

    return newState;
  },
});
